import crypto from "crypto-js";
export const hashText = (message: string) => {
  const hashHex = crypto.SHA256(message).toString(crypto.enc.Hex);
  console.log(message, hashHex);
  return hashHex;
};
